/** Единый список статусов заявок на подключение и сервиса (карта, календарь). */

export const CONNECTION_APPLICATION_STATUSES = ['created', 'inspection', 'connected', 'unreachable'] as const;
export type ConnectionApplicationStatus = (typeof CONNECTION_APPLICATION_STATUSES)[number];

export const SERVICE_REQUEST_STATUSES = ['created', 'service', 'completed'] as const;
export type ServiceRequestStatus = (typeof SERVICE_REQUEST_STATUSES)[number];

export const CONNECTION_STATUS_LABELS: Record<string, string> = {
  created: 'Создана',
  inspection: 'Осмотр',
  connected: 'Подключена',
  unreachable: 'Невозможно',
};

export const SERVICE_STATUS_LABELS: Record<string, string> = {
  created: 'Создана',
  service: 'В работе',
  completed: 'Завершена',
};

/** Классы для мини-бейджа статуса в списках заявок (дашборд, сервис). */
export const CONNECTION_STATUS_CHIP_CLASSES: Record<string, string> = {
  created: 'bg-yellow-100 text-yellow-700',
  inspection: 'bg-orange-100 text-orange-700',
  connected: 'bg-green-100 text-green-700',
  unreachable: 'bg-red-100 text-red-700',
};

export const SERVICE_STATUS_CHIP_CLASSES: Record<string, string> = {
  created: 'bg-yellow-100 text-yellow-700',
  service: 'bg-orange-100 text-orange-700',
  completed: 'bg-green-100 text-green-700',
};

export function defaultConnectionStatuses(): Set<string> {
  return new Set(CONNECTION_APPLICATION_STATUSES);
}

export function defaultServiceStatuses(): Set<string> {
  return new Set(SERVICE_REQUEST_STATUSES);
}

/** Режим фильтра для пагинированного API (один query status). */
export type ListStatusApiMode = null | string | 'EMPTY' | 'MULTI';

export function connectionStatusesToListApiMode(s: Set<string>): ListStatusApiMode {
  if (s.size === 0) return 'EMPTY';
  if (CONNECTION_APPLICATION_STATUSES.every((st) => s.has(st))) return null;
  if (s.size === 1) return [...s][0];
  return 'MULTI';
}

export function serviceStatusesToListApiMode(s: Set<string>): ListStatusApiMode {
  if (s.size === 0) return 'EMPTY';
  if (SERVICE_REQUEST_STATUSES.every((st) => s.has(st))) return null;
  if (s.size === 1) return [...s][0];
  return 'MULTI';
}

/** Параметры GET календаря: undefined = все статусы типа; [] = не отдавать события типа. */
export function calendarConnectionServiceParams(
  connection: Set<string>,
  service: Set<string>
): { connectionStatus?: string[]; serviceStatus?: string[] } {
  const allConn =
    CONNECTION_APPLICATION_STATUSES.length > 0 &&
    CONNECTION_APPLICATION_STATUSES.every((s) => connection.has(s));
  const allSrv =
    SERVICE_REQUEST_STATUSES.length > 0 && SERVICE_REQUEST_STATUSES.every((s) => service.has(s));
  return {
    connectionStatus: allConn ? undefined : [...connection],
    serviceStatus: allSrv ? undefined : [...service],
  };
}
